module.exports = __webpack_public_path__ + "static/produto3-7bf6fba7f080b06f74465ca08268465d.jpg";